import styled from 'styled-components';
import { colors } from '@/styles';

export const NamespaceHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
`;

export const NamespaceInfo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const NamespacePath = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: var(--font-size-headline5);
  .separator {
    color: ${colors.semantic.disabled};
  }
`;

export const NamespaceActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
